// Migrated to Polaris Web Components
import React, { useCallback, useEffect } from "react";

export default function DeleteModal({ setActive, active, handleDelete, itemName }) {

    const handleChange = useCallback(() => setActive((active) => !active), [setActive]);

    const onConfirmDelete = () => {
        handleDelete();
        setActive(false);
    };

    // Handle modal visibility based on active prop
    useEffect(() => {
        const modal = document.getElementById('delete-modal');
        if (modal) {
            if (active && modal.showOverlay) {
                modal.showOverlay();
            } else if (!active && modal.hideOverlay) {
                modal.hideOverlay();
            }
        }
    }, [active]);

    return (
        <s-modal id="delete-modal" heading={`Delete ${itemName}`}>
                <s-stack gap="large">
                    <s-text color="subdued">
                        Are you sure you want to delete this item <s-text type="strong">{itemName}</s-text>? This action cannot be undone.
                    </s-text>
                </s-stack>
            <s-button
                slot="secondary-actions"
                commandFor="delete-modal"
                command="--hide"
                onClick={handleChange}
            >
                Cancel
            </s-button>
            <s-button
                slot="primary-action"
                variant="primary"
                tone="critical"
                onClick={onConfirmDelete}
                commandFor="delete-modal"
                command="--hide"
            >
                Delete
            </s-button>
        </s-modal>
    );
}
